import { useEffect, useRef, useState } from 'react';

import moment from 'moment-timezone';

import { User } from '../../classess/user/user';
import { Status, } from '../../classess/status/status';
import { Customer, } from '../../classess/customer/customer';
import { Requirement, } from '../../classess/requirement/requirement';
import { RequirementDetail } from '../../classess/requirement/requirementDetail';

import Swal from 'sweetalert2';

import { GlobalFormats } from '../../classess/main/globalFormats';

import {
    badgetStatusGeneric, getProcessButtons, dataTableLanguaje, setDateTimeFormatGlobalString, getDtRowIndex, isUndNullEmp, isValidDate, getLanguageObj,
    getResponse, getRolesType, handleResponseMessageAsync, settings, styles, getUserRoles, LoadingSection, awaitDelayAsync, isUndNull,
} from '../../helpers/main';
import { RequirementService } from '../../services/requirements/RequirementService';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import parse from 'html-react-parser';
import RequirementDetailAddEditDetail from './RequirementDetailAddEditDetail';

const $ = window.jqGlobal || window.jQuery;

const { backend, html, colors, icons, images, labels, messages, } = settings;

const currentMethod = 'RequirementEdit';

export default function RequirementEdit({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const isMount = useRef(false);
    const auth = useAuth();
    const { type = '', id = 0 } = useParams();
    const [viewType] = useState(type === labels?.edit?.en?.toLowerCase() ?
        1 :
        (type === labels?.details?.en?.toLowerCase() ? 2 : 0));

    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    let userRoles = getRolesType();
    userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod, })?.result;

    const [process, setProcess] = useState({
        showLoading: true,
        save: false,
        back: false,
        detail: false,
        edit: false,
        delete: false,
        report: false,
        selUserCustomerDisabled: true,
        selAnalystDisabled: true,
        selUserDisabled: true,
    });

    const dtRequirementDetailsId = 'dtRequirementDetails';
    const [showData, setShowData] = useState(true);
    const rdFieldViewsObj = {
        commentary: '',
        registerDate: {
            date: '',
            time: ''
        },
        requirement: {
            id: 0,
        },
        users: {
            analyst: {
                name: '',
            },
        },
    };
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        languageObj: languageObj,
        dtRequirementDetailsId: dtRequirementDetailsId,
        dtRequirementDetailsRowId: 0,
        requirement: Requirement.getClass({}, false),
        requirementDetail: RequirementDetail.getClass({}, false),
        rdFieldViews: rdFieldViewsObj,
        analysts: [User?.getClass({}, false)],
        userRoles: userRoles,
    });
    const controls = {
        buttons: {
            addDetail: {
                defaultClass: 'btn btn-warning shadow-sm font-weight-bold mx-1 px-4 text-dark',
                id: 'btnAddRequirement',
            },
            back: {
                defaultClass: 'btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary',
                id: 'btnBack',
            },
            edit: {
                defaultClass: 'btn btn-warning shadow-sm font-weight-bold mx-1 px-4 text-dark',
                id: 'btnEdit',
            },
            report: {
                defaultClass: 'btn btn-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnReport',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnSave',
            },
        },
        checkBoxs: {
            informCreation: {
                id: 'chkInformCreation',
                defaultClass: '',
            },
            informCompletion: {
                id: 'chkInformCompletion',
                defaultClass: '',
            }
        },
        dataTables: {
            requirements: {
                inputs: {
                    search: {
                        id: `${dtRequirementDetailsId}_filter input`,
                        defaultClass: 'form-control form-control-sm bg-light border-0 shadow-sm ml-2',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtRequirementDetailsId}_length select`,
                        defaultClass: '',
                    },
                },
                paginateds: {
                    paginated: {
                        id: `${dtRequirementDetailsId}_paginate`,
                        defaultClass: '',
                    },
                },
            },
            columns: {
                process: {
                    id: 5,
                },
            },
        },
        icons: {
            addDetail: {
                id: 'iconAddDetail',
                defaultClass: icons?.fasFa?.list,
            },
            edit: {
                id: 'iconEdit',
                defaultClass: icons?.fasFa?.edit,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
            report: {
                id: 'iconReport',
                defaultClass: icons?.fasFa?.fileAlt,
            },
            save: {
                id: 'iconSave',
                defaultClass: icons?.fasFa?.save,
            },
        },
        inputs: {
            authorizedBy: {
                id: 'inputAuthorizedBy',
                defaultClass: 'form-control bg-light border-0 shadow-sm',
            },
            contactPerson: {
                id: 'inputContactPerson',
                defaultClass: 'form-control bg-light border-0 shadow-sm',
            },
            department: {
                id: 'inputDepartment',
                defaultClass: 'form-control bg-light border-0 shadow-sm',
            },
            informCreationDate: {
                id: 'inputInformCreationDate',
                defaultClass: 'form-control bg-light border-0 shadow-sm',
            },
            informCompletionDate: {
                id: 'inputInformCompletionDate',
                defaultClass: 'form-control bg-light border-0 shadow-sm',
            },
            number: {
                id: 'inpuntNumber',
                defaultClass: 'form-control bg-light border-0 shadow-sm',
            },
            userRegisterDate: {
                id: 'inputUserRegisterDate',
                defaultClass: 'form-control datetimepicker-input bg-light border-0 shadow-sm',
            },
            visitDate: {
                id: 'inputVisitDate',
                defaultClass: 'form-control datetimepicker-input bg-light border-0 shadow-sm',
            },
        },
        pickers: {
            userRegisterDate: {
                id: 'pkRegisterDate',
            },
            visitDate: {
                id: 'pkVisitDate',
            },
        },
        selects: {
            analysts: {
                id: 'selAnalyst',
                defaultClass: 'custom-select bg-light border-0 shadow-sm',
            },
            customers: {
                id: 'selCustomer',
                defaultClass: 'custom-select bg-light border-0 shadow-sm',
            },
            userCustomer: {
                id: 'selUserCustomer',
                defaultClass: 'custom-select bg-light border-0 shadow-sm',
            },
            informCreationUser: {
                id: 'selInformCreationUser',
                defaultClass: 'custom-select bg-light border-0 shadow-sm',
            },
            informCompletionUser: {
                id: 'selInformCompletionUser',
                defaultClass: 'custom-select bg-light border-0 shadow-sm',
            },
            status: {
                id: 'selStatus',
                defaultClass: 'custom-select bg-light border-0 shadow-sm',
            },
        },
        spiners: {
            addDetail: {
                id: 'spAddDetail',
                defaultClass: '',
            },
            back: {
                id: 'spBack',
                defaultClass: '',
            },
            edit: {
                id: 'spEdit',
                defaultClass: '',
            },
            report: {
                id: 'spReport',
                defaultClass: '',
            },
            save: {
                id: 'spSave',
                defaultClass: '',
            },
        },
        textAreas: {
            commentary: {
                id: 'txtAreaCommentary',
                defaultClass: 'form-control bg-light border-0 shadow-sm',
            }
        }
    };
    const urlBack = `${backend?.urls?.requirements}/`;

    const [users, setUsers] = useState([User?.getClass({}, false)]);
    const [status, setStatus] = useState([Status?.getClass({}, false)]);
    const [customersView, setCustomersView] = useState([Customer?.getClass({}, false)]);
    const [customers, setCustomers] = useState([]);
    const [analysts, setAnalysts] = useState([User?.getClass({}, false)]);
    const [userCustomers, setUserCustomers] = useState([User?.getClass({}, false)]);
    const [requirement, setRequirement] = useState(Requirement.getClass({}, false));
    const [requirementBefore, setRequirementBefore] = useState(Requirement.getClass({}, false));
    const [userCompanyCustomers, setUserCompanyCustomers] = useState([]);

    const rFieldsViewObj = {
        status: '',
        register: {
            date: '',
            time: ''
        },
        visit: {
            date: '',
            time: ''
        },
        users: {
            analyst: {
                name: '',
            },
            customer: {
                name: '',
            },
            user: {
                name: '',
            },
        },
    };
    const [rFieldsView, setRFieldsView] = useState(rFieldsViewObj);

    const [errors, setErrors] = useState({
        user: '',
        customer: '',
        analyst: '',
        registerDate: '',
        visitDate: '',
        authorizedBy: '',
        contactPerson: '',
        department: '',
        commentary: '',
        informCreationUser: '',
    });

    const [dataFormLength] = useState(Requirement.minMaxLength(false));
    //#endregion variables

    //#region methods
    //#region requirement
    const editRequirement = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'editRequirement';
        try {
            e?.preventDefault?.();

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            const requirementSetData = response?.result?.requirement || requirement;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true, showLoading: true, }));

            //#region update requirement
            response = await RequirementService.update({
                auth,
                data: requirementSetData,
                id: requirementSetData?.id,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            //#region variables
            const usersData = response?.result?.users.sort((a, b) => a.firstName.toLowerCase().trim() > b.firstName.toLowerCase().trim() ? 1 : -1) || [];
            const statusData = response?.result?.status.sort((a, b) => a.name.toLowerCase().trim() > b.name.toLowerCase().trim() ? 1 : -1) || [];
            const analystsData = response?.result?.analysts.sort((a, b) => a.firstName.toLowerCase().trim() > b.firstName.toLowerCase().trim() ? 1 : -1) || [];
            const customersData = response?.result?.customers.sort((a, b) => a.name.toLowerCase().trim() > b.name.toLowerCase().trim() ? 1 : -1) || [];
            const requirementData = response?.result?.requirement || {};
            const requirementDetailsData = response?.result?.requirementDetails || [];
            const userCustomersData = response?.result?.userCustomers.sort((a, b) => a.firstName.toLowerCase().trim() > b.firstName.toLowerCase().trim() ? 1 : -1) || [];
            const userCompanyCustomersData = response?.result?.userCompanyCustomers || [];
            //#endregion variables

            //#region set data
            setUsers(usersData);
            setStatus(statusData);
            setAnalysts(analystsData);
            setCustomers(customersData);
            setRequirement(requirementData);
            setRequirementBefore(requirementData);
            setUserCustomers(userCustomersData);
            setUserCompanyCustomers(userCompanyCustomersData);
            //#endregion set data

            //#region checkbox (set status)
            if (requirementData?.informCreation) {
                $(`#${controls.checkBoxs.informCreation.id}`).attr({ 'disabled': true });
            }
            if (requirementData?.informCompletion) {
                $(`#${controls.checkBoxs.informCompletion.id}`).attr({ 'disabled': true });
            }
            //#endregion checkbox (set status)

            $(`#${dtRequirementDetailsId}`).DataTable()?.rows()?.clear()?.draw(true);

            //#region set datatable
            if (requirementDetailsData.length > 0) {
                response = setDataInDataTable({
                    data: requirementDetailsData,
                    analysts_: analystsData,
                    status: statusData,
                    subMethod: currentMethod,
                });
            }
            //#endregion set datatable
            //#endregion update requirement

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, save: false, showLoading: false, }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const setRequirementInformCreationComplete = ({
        e = {},
        id = '',
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setRequirementInformCreationComplete';
        try {
            const dateTime = moment(new Date())?.format(`${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f2}.000Z`);

            switch (id) {
                case controls.checkBoxs.informCreation.id:
                    setRequirement(prev => ({
                        ...prev,
                        informCreation: e?.target?.checked,
                        informCreationDate: e?.target?.checked ? dateTime : requirementBefore?.informCreationDate,
                    }));
                    break;
                case controls.checkBoxs.informCompletion.id:
                    setRequirement(prev => ({
                        ...prev,
                        informCompletion: e?.target?.checked,
                        informCompletionDate: e?.target?.checked ? dateTime : requirementBefore?.informCompletionDate,
                    }));
                    break;
                default:
                    break;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const getRequirementReport = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getRequirementReport';
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, report: true, showLoading: true, }));

            //#region get data (requirement report)
            response = await RequirementService.getReport({
                auth,
                id: requirement?.id || 0,
                languageCode: languageObj?.code,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion get data (requirement report)

            window.open(response?.result, '_blank', 'noopener,noreferrer');
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, report: false, showLoading: false, }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }
    //#endregion requirement

    //#region requirementdetails
    const getRequirementDetailAdd = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getRequirementDetailAdd';
        try {
            e?.preventDefault?.();

            //#region check role
            if (!userRoles?.isAdmin && !userRoles?.isAnalyst) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`;
                return;
            }
            //#endregion check role

            setProcess(prev => ({ ...prev, detail: true, showLoading: true, }));

            await awaitDelayAsync({ delayTime: settings?.timers?.oneSecond });

            //#region set data
            setModalObj(prev => ({
                ...prev,
                analysts: analysts,
                requirement: requirement,
                requirementDetail: {
                    ...RequirementDetail.getClass({
                        requirementId: requirement?.id,
                        registerDate: moment(new Date())?.format(`${languageObj?.format?.date?.f13} ${languageObj?.format?.time?.f2}`),
                        register: new Date().toISOString(),
                    },
                        false
                    ),
                },
                showModal: true,
                type: 0,
            }));
            //#endregion set data
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, detail: false, showLoading: false, }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const getRequirementDetailEdit = async ({
        e = {},
        id = 0,
        description = '',
        rowId = 0,
        type = 1,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getRequirementDetailEdit';
        try {
            e?.preventDefault?.();

            //#region check role
            if (!userRoles?.isAdmin && !userRoles?.isAnalyst) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`;
                return;
            }
            //#endregion check role

            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region requirementdetail (get byid)
            response = await RequirementService.getDetailById({
                auth,
                id: id,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#region variables
            const rdFieldViews = { ...rdFieldViewsObj };
            const requirementDetailData = response?.result?.requirementDetail || {};
            const analystsData = response?.result?.analysts || [];
            //#endregion variables

            //#region check data
            if (isUndNullEmp({ data: requirementDetailData, subMethod: currentMethod })?.result) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/><b>${description}</b><br/>`;
                return;
            }
            //#endregion check data

            //#region requirementdetail (set fieldviews)
            if (type === 2) {
                //#region set data
                rdFieldViews.requirement.id = requirementDetailData?.requirementId || 0;
                rdFieldViews.registerDate.date = setDateTimeFormatGlobalString({
                    date: requirementDetailData?.registerDate,
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: 0,
                    withSeconds: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                rdFieldViews.registerDate.time = setDateTimeFormatGlobalString({
                    date: requirementDetailData?.registerDate,
                    dateFormat: '',
                    timeFormat: languageObj?.format?.time?.type,
                    withSeconds: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                const modelAnalyst = analystsData?.filter(({ id }) => id === requirementDetailData?.analystId)[0] || {};
                rdFieldViews.users.analyst.name = `${modelAnalyst.firstName || ''} - ${modelAnalyst.lastName || ''}`;
                rdFieldViews.commentary = requirementDetailData?.commentary;
                //#endregion set data
            }
            //#endregion requirementdetail (set fieldviews)

            //#region set data
            setAnalysts(analystsData);
            setModalObj(prev => ({
                ...prev,
                analysts: analystsData,
                dtRequirementDetailsRowId: rowId,
                requirement: { ...requirement, id: requirementDetailData?.requirementId },
                requirementDetail: requirementDetailData,
                rdFieldViews: rdFieldViews,
                showModal: true,
                type: type,
            }));
            //#endregion set data

            //#endregion requirementdetail (get byid)
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const deleteRequirementDetail = async ({
        e = {},
        id_ = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'deleteRequirementDetail';
        try {
            e?.preventDefault?.();

            //#region show message
            let msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.detail?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };
            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                showConfirmButton: !Swal.isLoading(),
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete data (requirementDetail)
                        preConfirmResponse = await RequirementService.deleteDetail({
                            auth,
                            id: id_,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (requirementDetail)

                        $(`#${dtRequirementDetailsId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);

                        preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        preConfirmResponse.msgText += `Sub method: preConfirm<br/>`;
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire(swalProperties);
            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
        return response;
    }
    //#endregion requirementdetails

    //#region customers
    const setUserCustomersFunc = ({
        id = '',
        requirement_ = {},
        _customers = [],
        _userCompanyCustomers = [],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setUserCustomersFunc';
        try {
            const dataUserCompanyCustomers = _userCompanyCustomers?.length > 0 ?
                _userCompanyCustomers :
                userCompanyCustomers;
            const dataCustomers = _customers?.length > 0 ?
                _customers :
                customers;
            const dataRequirement = !isUndNullEmp({ data: requirement_, subMethod: currentMethod })?.result ?
                requirement_ :
                requirement;

            const userCustomersData = dataUserCompanyCustomers?.filter(({ userId }) => userId === id) || [];
            const ids = userCustomersData?.map(({ customerId }) => customerId) || [];
            const resultCustomers = dataCustomers?.filter(({ id }) => ids?.includes(id)) || [];

            setCustomersView(resultCustomers);

            const requirementUpdate = { ...dataRequirement, userId: id };
            if (resultCustomers?.length === 1) {
                requirementUpdate.customerId = resultCustomers[0]?.id;
            } else if (resultCustomers?.length > 1) {
                if (!ids?.includes(dataRequirement?.customerId)) {
                    requirementUpdate.customerId = 0;
                }
            } else {
                requirementUpdate.customerId = 0;
            }
            setRequirement(requirementUpdate);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }
    //#endregion customers

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region check type (url)
            if (isUndNullEmp({ data: id, subMethod: currentMethod })?.result || parseInt(id) <= 0) {
                window.location.href = `${backend?.urls?.notFound}`;
                return;
            }

            if (type !== labels?.edit?.en?.toLowerCase() && type !== labels?.details?.en?.toLowerCase()) {
                window.location.href = `${backend?.urls?.notFound}`;
                return;
            }
            //#endregion check type (url)

            if (!auth?.isLoged({ subMethod: currentMethod })?.result) window.location.href = urlBack;

            //#region datatable (set)
            response = setDataTables({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion datatable (set)

            //#region set query code
            response = setQueryCode({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set query code

            //#region check role
            if (viewType === 1 && !userRoles?.isAdmin && !userRoles?.isAnalyst) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`;
                return;
            }
            //#endregion check role

            //#region get data (requirement)
            response = await RequirementService.getById({
                auth,
                id: id,
                languageId: languageObj?.id,
                withDetails: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#region variables
            const usersData = response?.result?.users.sort((a, b) => a.firstName.toLowerCase().trim() > b.firstName.toLowerCase().trim() ? 1 : -1) || [];
            const statusData = response?.result?.status.sort((a, b) => a.name.toLowerCase().trim() > b.name.toLowerCase().trim() ? 1 : -1) || [];
            const analystsData = response?.result?.analysts.sort((a, b) => a.firstName.toLowerCase().trim() > b.firstName.toLowerCase().trim() ? 1 : -1) || [];
            const customersData = response?.result?.customers.sort((a, b) => a.name.toLowerCase().trim() > b.name.toLowerCase().trim() ? 1 : -1) || [];
            const requirementData = response?.result?.requirement || {};
            const requirementDetailsData = response?.result?.requirementDetails || [];
            const userCustomersData = response?.result?.userCustomers.sort((a, b) => a.firstName.toLowerCase().trim() > b.firstName.toLowerCase().trim() ? 1 : -1) || [];
            const userCompanyCustomersData = response?.result?.userCompanyCustomers || [];
            //#endregion variables

            //#region set data values
            setUsers(usersData);
            setStatus(statusData);
            setAnalysts(analystsData);
            setCustomers(customersData);
            setCustomersView(customersData);
            setRequirement(requirementData);
            setRequirementBefore(requirementData);
            setUserCustomers(userCustomersData);
            setUserCompanyCustomers(userCompanyCustomersData);
            //#endregion set data values

            //#region check data
            if (isUndNullEmp({ data: requirementData, subMethod: currentMethod })?.result) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/>`;
                return;
            }
            //#endregion check data

            //#region user customers logic
            response = setUserCustomersFunc({
                id: requirementData?.userId,
                requirement_: requirementData,
                _customers: customersData,
                _userCompanyCustomers: userCompanyCustomersData,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion user customers logic

            //#region set disables
            setProcess(prev => ({
                ...prev,
                selUserDisabled: !(userRoles?.isAdmin || userRoles?.isAnalyst),
                selAnalystDisabled: !(userRoles?.isAdmin || userRoles?.isAnalyst),
                selUserCustomerDisabled: !(userRoles?.isAdmin || userRoles?.isAnalyst),
            }));
            //#endregion set disables

            //#region field views (set)
            if (viewType === 2) {
                setFieldViews({
                    requirement_: requirementData,
                    userCustomers_: userCustomersData,
                    analysts_: analystsData,
                    users_: usersData,
                    status_: statusData,
                    subMethod: currentMethod,
                });
            }
            //#endregion field views (set)

            //#region set date controls
            response = setDateInControl({
                date: new Date().toISOString(),
                userRegisterDate: requirementData?.userRegisterDate,
                visitDate: requirementData?.visitDate,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set date controls

            //#region checkbox set data
            if (viewType === 1) {
                if (requirementData?.informCreation) {
                    $(`#${controls.checkBoxs.informCreation.id}`).attr({
                        'checked': true,
                        'disabled': true,
                    });
                }
                if (requirementData?.informCompletion) {
                    $(`#${controls.checkBoxs.informCompletion.id}`).attr({
                        'checked': true,
                        'disabled': true,
                    });
                }
            } else {
                $(`#${controls.checkBoxs.informCreation.id}`).attr({
                    'checked': requirementData?.informCreation,
                    'disabled': true,
                });
                $(`#${controls.checkBoxs.informCompletion.id}`).attr({
                    'checked': requirementData?.informCompletion,
                    'disabled': true,
                });
            }
            //#endregion checkbox set data

            //#region set datatable
            if (requirementDetailsData.length > 0) {
                setDataInDataTable({
                    data: requirementDetailsData,
                    analysts_: analystsData,
                    status: statusData,
                    subMethod: currentMethod,
                });
            }
            //#endregion set datatable

            //#region process column (set visible)
            if (viewType === 2) {
                $(`#${dtRequirementDetailsId}`).DataTable().column(controls.dataTables.columns.process.id).visible(false);
            }
            //#endregion process column (set visible)

            //#endregion get data (requirement)
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const goToBack = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'goToBack';
        try {
            setProcess(prev => ({ ...prev, back: true, showLoading: true, }));
            await awaitDelayAsync({ delayTime: settings?.timers?.oneSecond });
            window.location.href = urlBack;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, back: false, showLoading: false, }));
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const goToEdit = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'goToEdit';
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, edit: true, showLoading: true, }));
            await awaitDelayAsync({ delayTime: settings?.timers?.oneSecond });

            window.location.href = `${backend?.urls?.requirements}/${labels?.edit?.en?.toLowerCase()}/${requirement?.id || 0}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, edit: false, showLoading: false, }));
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const setFieldViews = ({
        requirement_ = {},
        userCustomers_ = [],
        analysts_ = [],
        users_ = [],
        status_ = [],
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setFieldViews';
        try {
            const _fieldsViewObj = { ...rFieldsViewObj };

            if (!isUndNullEmp({ data: requirement_, subMethod: currentMethod })?.result && requirement_?.id > 0) {
                const modelRequirement = Requirement.getClass(requirement_, false);

                //#region status
                const modelStatus = status_?.length > 0 ?
                    status_?.filter(({ id }) => id === modelRequirement?.statusId)[0] || {} :
                    status?.filter(({ id }) => id === modelRequirement?.statusId)[0] || {};

                if (!isUndNullEmp({ data: modelStatus, subMethod: currentMethod })?.result && modelStatus?.id > 0) {
                    const statusLabel = !isUndNullEmp({ data: modelStatus?.label, subMethod: currentMethod }) ?
                        modelStatus.label :
                        `${modelStatus?.name.replace(' ', '').charAt(0).toLowerCase()}${modelStatus?.name.replace(' ', '').slice(1)}`;

                    response.result = badgetStatusGeneric({
                        type: (modelRequirement?.statusId || 5) === 1 ?
                            1 : (modelRequirement?.statusId || 5) === 2 ?
                                5 : (modelRequirement?.statusId || 5) === 3 ?
                                    3 : (modelRequirement?.statusId || 5) === 4 ?
                                        0 : (modelRequirement?.statusId || 5) === 5 ?
                                            -1 : (modelRequirement?.statusId || 5) === 6 ?
                                                2 : (modelRequirement?.statusId || 5),
                        value: labels?.[statusLabel]?.[languageObj?.id] || 'undefined',
                    });
                    _fieldsViewObj.status = response?.result;
                }
                //#endregion status

                //#region userregisterdate
                response = setDateTimeFormatGlobalString({
                    date: modelRequirement?.userRegisterDate,
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: languageObj?.format?.time?.type,
                    withSeconds: 0,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return response;
                _fieldsViewObj.register.date = response?.result;
                //#endregion userregisterdate

                //#region visitdate
                response = setDateTimeFormatGlobalString({
                    date: modelRequirement?.visitDate,
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: languageObj?.format?.time?.type,
                    withSeconds: 0,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return response;
                _fieldsViewObj.visit.date = response?.result;
                //#endregion visitdate

                //#region usercustomer
                _fieldsViewObj.users.customer.name = userCustomers_?.length > 0 ?
                    `${userCustomers_?.filter(({ id, }) => id === modelRequirement?.userId)[0]?.firstName || ''} - ${userCustomers_?.filter(({ id, }) => id === modelRequirement?.userId)[0]?.lastName || ''}` :
                    `${userCustomers?.filter(({ id, }) => id === modelRequirement?.userId)[0]?.firstName || ''} - ${userCustomers?.filter(({ id, }) => id === modelRequirement?.userId)[0]?.lastName || ''}`;
                //#endregion usercustomer

                //#region analyst
                _fieldsViewObj.users.analyst.name = analysts_?.length > 0 ?
                    `${analysts_?.filter(({ id, }) => id === modelRequirement?.analystId)[0]?.firstName || ''} - ${analysts_?.filter(({ id, }) => id === modelRequirement?.analystId)[0]?.lastName || ''}` :
                    `${analysts?.filter(({ id, }) => id === modelRequirement?.analystId)[0]?.firstName || ''} - ${analysts?.filter(({ id, }) => id === modelRequirement?.analystId)[0]?.lastName || ''}`;
                //#endregion analyst

                //#region user
                _fieldsViewObj.users.user.name = users_?.length > 0 ?
                    `${users_?.filter(({ id, }) => id === modelRequirement?.userId)[0]?.firstName || ''} - ${users_?.filter(({ id, }) => id === modelRequirement?.userId)[0]?.lastName || ''}` :
                    `${users?.filter(({ id, }) => id === modelRequirement?.userId)[0]?.firstName || ''} - ${users?.filter(({ id, }) => id === modelRequirement?.userId)[0]?.lastName || ''}`;
                //#endregion user

                setRFieldsView(_fieldsViewObj);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtRequirementDetailsId}`).DataTable({
                columns: [
                    { title: 'dateTime', width: '0%', orderable: false, searchable: false, visible: false, },
                    { title: labels?.date?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.time[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.analyst?.[languageObj?.id], width: '15%', orderable: false, },
                    { title: labels?.commentary?.[languageObj?.id], width: '60%', orderable: false, },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                info: true,
                paging: true,
                searching: true,
            });
            //.buttons().container().appendTo(`#${dtRequirementDetailsId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setQueryCode';
        try {
            //#region variables
            let id_ = '';
            let methodName = '';
            let description = '';
            let rowId = 0;
            //#endregion variables

            //#region process
            $(`#${dtRequirementDetailsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowId = getDtRowIndex({ dtId: dtRequirementDetailsId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id_ = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getRequirementDetailEdit({ e: e, id: id_, description: description, rowId: rowId, type: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            getRequirementDetailEdit({ e: e, id: id_, description: description, rowId: rowId, type: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            deleteRequirementDetail({ e: e, id_: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        analysts_ = [],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            //#region variables
            let rowData = [];
            //#endregion variables

            //#region process
            rowData = data.map((requirementDetail) => {
                //#region variables
                const modelRequirementDetail = RequirementDetail.getClass(requirementDetail, false);
                const modelAnalyst = User?.getClass(analysts_?.filter(({ id }) => id === modelRequirementDetail?.analystId)[0] || {}, false);
                const dateTime = modelRequirementDetail.registerDate;
                const date = setDateTimeFormatGlobalString({
                    date: modelRequirementDetail?.registerDate,
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: 0,
                    withSeconds: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                const time = setDateTimeFormatGlobalString({
                    date: modelRequirementDetail?.registerDate,
                    dateFormat: '',
                    timeFormat: languageObj?.format?.time?.type,
                    withSeconds: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                const analystFullName = `${modelAnalyst?.firstName || ''} - ${modelAnalyst?.lastName || ''}`;
                const buttonDescription = `${date} ${time} - ${analystFullName}`;

                const processButtons = [];
                //#endregion variables

                return [
                    dateTime,
                    date,
                    time,
                    analystFullName,
                    modelRequirementDetail?.commentary || '',
                    getProcessButtons({
                        id: modelRequirementDetail.id,
                        description: buttonDescription,
                        showDetails: true,
                        labelDetails: labels?.details?.[languageObj?.id],
                        enabledDetails: true,
                        showDelete: userRoles?.isAdmin || userRoles?.isAnalyst,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: userRoles?.isAdmin || userRoles?.isAnalyst,
                        showEdit: userRoles?.isAdmin || userRoles?.isAnalyst,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: userRoles?.isAdmin || userRoles?.isAnalyst,
                        processButtons: processButtons,
                    })?.result,
                ];
            });

            $(`#${dtRequirementDetailsId}`)?.DataTable()?.rows?.add(rowData)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDateInControl = ({
        date = undefined,
        userRegisterDate = undefined,
        visitDate = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDateInControl';
        try {
            let userRegisterDateVal = '';
            let visitDateVal = '';
            const tf = languageObj?.format?.time?.type;
            const dtf = `${languageObj?.format?.date?.f11} ${languageObj?.format?.time?.picker?.hhmm}`;
            const df = languageObj?.format?.date?.f1;

            if (!isUndNullEmp({ data: userRegisterDate, subMethod: currentMethod })?.result) {
                userRegisterDateVal = setDateTimeFormatGlobalString({ date: userRegisterDate, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod })?.result) {
                userRegisterDateVal = setDateTimeFormatGlobalString({ date: date, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            }

            if (!isUndNullEmp({ data: visitDate, subMethod: currentMethod })?.result) {
                visitDateVal = setDateTimeFormatGlobalString({ date: visitDate, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod })?.result) {
                visitDateVal = setDateTimeFormatGlobalString({ date: date, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: settings?.react?.tempusDominus?.icons,
                buttons: settings?.react?.tempusDominus?.buttons,
                tooltips: settings?.react?.tempusDominus?.tooltips({ languageId: languageObj?.id }),
                locale: languageObj?.id,
            });

            $(`#${controls?.pickers?.userRegisterDate?.id}`)?.datetimepicker('options', {
                date: userRegisterDateVal,
                default: false,
                timepicker: true,
                format: dtf,
            });

            $(`#${controls?.pickers?.visitDate?.id}`)?.datetimepicker('options', {
                date: visitDateVal,
                default: false,
                timepicker: true,
                format: dtf,
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setErrorsDefault';
        try {
            setErrors({
                user: '',
                customer: '',
                analyst: '',
                registerDate: '',
                visitDate: '',
                authorizedBy: '',
                contactPerson: '',
                department: '',
                commentary: '',
                informCreationUser: '',
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setData';
        try {
            const userRegisterDate = $(`#${controls?.pickers?.userRegisterDate?.id}`)?.datetimepicker('date')?._d;
            const visitDate = $(`#${controls?.pickers?.visitDate?.id}`)?.datetimepicker('date')?._d;

            const requirementUpdate = {
                ...requirement,
                userRegisterDate: moment(userRegisterDate).format(`${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f2}.000Z`),
                visitDate: moment(visitDate).format(`${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f2}.000Z`),
            };

            setRequirement(requirementUpdate);
            response.result = { requirement: requirementUpdate };
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            const userRegisterDate = $(`#${controls?.inputs?.userRegisterDate.id}`).val();
            const visitDate = $(`#${controls?.inputs?.visitDate.id}`).val();

            const newErrors = { ...errors };
            let hasErrors = false;

            if (isUndNullEmp({ data: requirement?.userId, subMethod: currentMethod })?.result) {
                newErrors.user = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
                hasErrors = true;
            }

            if (isUndNullEmp({ data: requirement?.customerId, subMethod: currentMethod })?.result ||
                parseInt(requirement?.customerId) <= 0) {
                newErrors.customer = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
                hasErrors = true;
            }

            if (isUndNullEmp({ data: requirement?.analystId, subMethod: currentMethod })?.result) {
                newErrors.analyst = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
                hasErrors = true;
            }

            if (isUndNullEmp({ data: userRegisterDate, subMethod: currentMethod })?.result) {
                newErrors.registerDate = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
                hasErrors = true;
            } else if (!isValidDate({ data: userRegisterDate, subMethod: currentMethod })?.result) {
                newErrors.registerDate = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
                hasErrors = true;
            }

            if (isUndNullEmp({ data: visitDate, subMethod: currentMethod })?.result) {
                newErrors.visitDate = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
                hasErrors = true;
            } else if (!isValidDate({ data: visitDate, subMethod: currentMethod })?.result) {
                newErrors.visitDate = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
                hasErrors = true;
            }

            if (isUndNullEmp({ data: requirement?.authorizedBy, subMethod: currentMethod })?.result) {
                newErrors.authorizedBy = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
                hasErrors = true;
            }

            if (isUndNullEmp({ data: requirement?.contactPerson, subMethod: currentMethod })?.result) {
                newErrors.contactPerson = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
                hasErrors = true;
            }

            if (isUndNullEmp({ data: requirement?.department, subMethod: currentMethod })?.result) {
                newErrors.department = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
                hasErrors = true;
            }

            if (isUndNullEmp({ data: requirement?.commentary, subMethod: currentMethod })?.result) {
                newErrors.commentary = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
                hasErrors = true;
            }

            if (isUndNullEmp({ data: requirement?.informCreationUserId, subMethod: currentMethod })?.result) {
                newErrors.informCreationUser = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
                hasErrors = true;
            }

            if (hasErrors) {
                setErrors(newErrors);
                response = getResponse({ type: 1 });
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={settings?.app?.views?.requirements?.requirements}
                process={settings?.app?.views?.requirements?.requirements} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.requirement?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={`${backend?.urls?.requirements}/`}>{labels?.requirements?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.edit?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Content Header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt='requirements'
                                                            style={styles?.cardHeaderLogo}
                                                            src={images?.icons?.requirements} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.requirement?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className={`badge badge-pill px-2 py-1 text-uppercase ${viewType === 1 ? 'badge-warning' : 'badge-secondary'}`}
                                                                style={html?.badges?.micro}>
                                                                <i className={`${viewType === 1 ? icons?.fasFa?.edit : icons?.fasFa?.eye} mr-1`}></i>
                                                                {viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>

                                                {viewType === 1 ? (
                                                    <form onSubmit={(e) => e?.preventDefault()}>
                                                        <div className='row'>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.hashTag}`} /> {labels?.number?.[languageObj?.id]}
                                                                    </small>
                                                                    <input id={controls?.inputs?.number?.id}
                                                                        disabled
                                                                        className={controls?.inputs?.number?.defaultClass}
                                                                        value={requirement?.id || 0}
                                                                        style={{ borderRadius: '5px' }} />
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.toggleOn}`} /> {labels?.status?.[languageObj?.id]}
                                                                    </small>
                                                                    <select id={controls?.selects?.status.id}
                                                                        disabled={process.selUserDisabled || process?.showLoading}
                                                                        className={controls?.selects?.status.defaultClass}
                                                                        value={requirement?.statusId || ''}
                                                                        style={{ borderRadius: '5px' }}
                                                                        onChange={(e) => setRequirement({ ...requirement, statusId: parseInt(e?.target?.value) })}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, informCreationUser: '' }))}>
                                                                        <option key={`nothing`} value={``}>{messages?.selectStatus?.[languageObj?.id]}</option>
                                                                        {status?.map((statu) => <option key={statu.id} value={statu.id}>{statu.name}</option>)}
                                                                    </select>
                                                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors.informCreationUser)}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'
                                                                    hidden={!userRoles?.isAdmin}>
                                                                    {!isUndNullEmp({ data: requirement?.userRegisterDate, subMethod: controls?.inputs?.userRegisterDate.id, })?.result && (
                                                                        <>
                                                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                                <i className={`${icons?.faFa?.calendarAlt}`} /> {labels?.registerDate?.[languageObj?.id]}
                                                                            </small>
                                                                            <div id={controls?.pickers?.userRegisterDate?.id}
                                                                                className='input-group date'
                                                                                data-target-input='nearest'>
                                                                                <input id={controls?.inputs?.userRegisterDate.id}
                                                                                    className={controls?.inputs?.userRegisterDate.defaultClass}
                                                                                    disabled={process?.showLoading}
                                                                                    style={{ borderRadius: '5px' }}
                                                                                    data-target={`#${controls?.pickers?.userRegisterDate?.id}`}
                                                                                    data-toggle='datetimepicker'
                                                                                    onFocus={() => setErrors(prev => ({ ...prev, registerDate: '' }))}
                                                                                    type='text' />
                                                                                <div className='input-group-append' data-target={`#${controls?.pickers?.userRegisterDate?.id}`} data-toggle='datetimepicker'>
                                                                                    <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors.registerDate)}</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='row'>
                                                            <div className='col-12 col-md-6'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.user}`} /> {labels?.user?.[languageObj?.id]}
                                                                    </small>
                                                                    <select id={controls?.selects?.userCustomer.id}
                                                                        disabled={process.selUserCustomerDisabled || process?.showLoading}
                                                                        className={controls?.selects?.userCustomer.defaultClass}
                                                                        style={{ borderRadius: '5px' }}
                                                                        value={!isUndNullEmp({ data: requirement?.userId, subMethod: controls?.selects?.userCustomer.id, })?.result ?
                                                                            requirement?.userId : ``
                                                                        }
                                                                        onChange={(e) => setUserCustomersFunc({ e: e, id: e?.target?.value, requirement_: {}, _customers: [], _userCompanyCustomers: [], subMethod: controls?.selects?.userCustomer.id, })}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, user: '' }))}>
                                                                        <option key={`nothing`} value={``}>{messages?.selectUser?.[languageObj?.id]}</option>
                                                                        {userCustomers.map((user) => <option key={user.id} value={user.id}>{user.firstName}, {user.lastName}</option>)}
                                                                    </select>
                                                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors.user)}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-6'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.building}`} /> {labels?.customer?.[languageObj?.id]}
                                                                    </small>
                                                                    <select id={controls?.selects?.customers?.id}
                                                                        className={controls?.selects?.customers?.defaultClass}
                                                                        disabled={process?.showLoading}
                                                                        style={{ borderRadius: '5px' }}
                                                                        value={!isUndNullEmp({ data: requirement?.customerId, subMethod: controls?.selects?.customers?.id, })?.result ?
                                                                            requirement?.customerId : ``
                                                                        }
                                                                        onChange={(e) => setRequirement({ ...requirement, customerId: parseInt(e?.target?.value) })}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, customer: '' }))}>
                                                                        <option key={`nothing`} value={`0`}>{messages?.selectCustomer?.[languageObj?.id]}</option>
                                                                        {customersView?.map((customer) => <option key={customer.id} value={customer.id}>{customer.name}</option>)}
                                                                    </select>
                                                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors.customer)}</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <hr className='opacity-50' />

                                                        <div className='row'>
                                                            <div className='col-12 col-md-6'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.userTie}`} /> {labels?.analyst?.[languageObj?.id]}
                                                                    </small>
                                                                    <select id={controls?.selects?.analysts?.id}
                                                                        disabled={process.selAnalystDisabled || process?.showLoading}
                                                                        className={controls?.selects?.analysts?.defaultClass}
                                                                        style={{ borderRadius: '5px' }}
                                                                        value={!isUndNullEmp({ data: requirement?.analystId, subMethod: controls?.selects?.analysts?.id, })?.result ?
                                                                            requirement?.analystId : ``
                                                                        }
                                                                        onChange={(e) => setRequirement({ ...requirement, analystId: e?.target?.value },)}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, analyst: '' }))}>
                                                                        <option key={`nothing`} value={``}>{messages?.selectAnalyst?.[languageObj?.id]}</option>
                                                                        {analysts.map((analyst) => <option key={analyst.id} value={analyst.id}>{analyst?.firstName}, {analyst?.lastName}</option>)}
                                                                    </select>
                                                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors.analyst)}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-6'>
                                                                <div className='form-group'>
                                                                    {!isUndNullEmp({ data: requirement?.visitDate, subMethod: controls?.inputs?.visitDate.id, })?.result && (
                                                                        <>
                                                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                                <i className={`${icons?.faFa?.calendarAlt}`} /> {labels?.visitDate?.[languageObj?.id]}
                                                                            </small>
                                                                            <div id={controls?.pickers?.visitDate?.id}
                                                                                className='input-group date'
                                                                                data-target-input='nearest'>
                                                                                <input id={controls?.inputs?.visitDate.id}
                                                                                    className={controls?.inputs?.visitDate.defaultClass}
                                                                                    disabled={process?.showLoading}
                                                                                    style={{ borderRadius: '5px' }}
                                                                                    data-target={`#${controls?.pickers?.visitDate?.id}`}
                                                                                    data-toggle='datetimepicker'
                                                                                    onFocus={() => setErrors(prev => ({ ...prev, visitDate: '' }))}
                                                                                    type='text' />
                                                                                <div className='input-group-append' data-target={`#${controls?.pickers?.visitDate?.id}`} data-toggle='datetimepicker'>
                                                                                    <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors.visitDate)}</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='row'>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.userShield}`} /> {labels?.authorizedBy?.[languageObj?.id]}
                                                                    </small>
                                                                    <input id={controls?.inputs?.authorizedBy.id}
                                                                        className={controls?.inputs?.authorizedBy.defaultClass}
                                                                        disabled={process?.showLoading}
                                                                        maxLength={dataFormLength?.max?.authorizedBy}
                                                                        style={{ borderRadius: '5px' }}
                                                                        onChange={(e) => setRequirement({ ...requirement, authorizedBy: e?.target?.value, })}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, authorizedBy: '' }))}
                                                                        value={!isUndNullEmp({ data: requirement?.authorizedBy, subMethod: controls?.inputs?.authorizedBy.id, })?.result ?
                                                                            requirement?.authorizedBy : ''} />
                                                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors.authorizedBy)}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.userTag}`} /> {labels?.contactPerson?.[languageObj?.id]}
                                                                    </small>
                                                                    <input id={controls?.inputs?.contactPerson.id}
                                                                        className={controls?.inputs?.contactPerson.defaultClass}
                                                                        disabled={process?.showLoading}
                                                                        maxLength={dataFormLength?.max?.contactPerson}
                                                                        style={{ borderRadius: '5px' }}
                                                                        onChange={(e) => setRequirement({ ...requirement, contactPerson: e?.target?.value, })}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, contactPerson: '' }))}
                                                                        value={!isUndNullEmp({ data: requirement?.contactPerson, subMethod: controls?.inputs?.contactPerson.id, })?.result ?
                                                                            requirement?.contactPerson : ''} />
                                                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors.contactPerson)}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.building}`} /> {labels?.department?.[languageObj?.id]}
                                                                    </small>
                                                                    <input id={controls?.inputs?.department?.id}
                                                                        className={controls?.inputs?.department.defaultClass}
                                                                        disabled={process?.showLoading}
                                                                        maxLength={dataFormLength?.max?.department}
                                                                        style={{ borderRadius: '5px' }}
                                                                        onChange={(e) => setRequirement({ ...requirement, department: e?.target?.value, })}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, department: '' }))}
                                                                        value={!isUndNullEmp({ data: requirement?.department, subMethod: controls?.inputs?.department?.id, })?.result ?
                                                                            requirement?.department : ''} />
                                                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors.department)}</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='form-group'>
                                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                <i className={`${icons?.fasFa?.edit}`} /> {labels?.commentary?.[languageObj?.id]}
                                                            </small>
                                                            <textarea id={controls.textAreas.commentary.id}
                                                                className={controls.textAreas.commentary.defaultClass}
                                                                disabled={process?.showLoading}
                                                                maxLength={dataFormLength?.max?.commentary}
                                                                style={{ borderRadius: '5px' }}
                                                                onChange={(e) => setRequirement({ ...requirement, commentary: e?.target?.value, })}
                                                                onFocus={() => setErrors(prev => ({ ...prev, commentary: '' }))}
                                                                rows={2}
                                                                value={!isUndNullEmp({ data: requirement?.commentary, subMethod: controls.textAreas.commentary.id })?.result ?
                                                                    requirement?.commentary : ''} />
                                                            <div className='form-text' style={styles?.labelMsgAlert}>{parse(errors.commentary)}</div>
                                                        </div>

                                                        <hr className='opacity-50' />

                                                        <div className='row'>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'>
                                                                    <div className='custom-control custom-switch' style={{ cursor: process?.showLoading ? 'default' : 'pointer' }}>
                                                                        <input id={controls.checkBoxs.informCreation.id}
                                                                            type='checkbox'
                                                                            className='custom-control-input'
                                                                            disabled={process?.showLoading}
                                                                            style={{ cursor: process?.showLoading ? 'default' : 'pointer' }}
                                                                            onClick={(e) => setRequirementInformCreationComplete({ e: e, id: e?.currentTarget?.id, subMethod: e?.currentTarget?.id })} />
                                                                        <label className='custom-control-label font-weight-bold text-muted text-uppercase small'
                                                                            style={{ cursor: process?.showLoading ? 'default' : 'pointer' }} htmlFor={controls.checkBoxs.informCreation.id}>
                                                                            {labels?.informCreation?.[languageObj?.id]}?
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.faFa?.calendarAlt}`} /> {labels?.date?.[languageObj?.id]}
                                                                    </small>
                                                                    <div id={controls?.pickers?.userRegisterDate?.id} className='input-group date' data-target-input='nearest'>
                                                                        <input id={controls?.inputs?.informCreationDate.id}
                                                                            readOnly
                                                                            className={controls?.inputs?.informCreationDate.defaultClass}
                                                                            style={{ borderRadius: '5px' }}
                                                                            value={!isUndNullEmp({ data: requirement?.informCreationDate, subMethod: controls?.inputs?.informCreationDate.id, })?.result ?
                                                                                setDateTimeFormatGlobalString({
                                                                                    date: requirement?.informCreationDate,
                                                                                    dateFormat: languageObj?.format?.date?.f1,
                                                                                    timeFormat: languageObj?.format?.time?.type,
                                                                                    withSeconds: false,
                                                                                    languageId: languageObj?.id,
                                                                                    subMethod: currentMethod
                                                                                })?.result : ''} />
                                                                        <div className='input-group-append' data-target={``}>
                                                                            <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.user}`} /> {labels?.user?.[languageObj?.id]}
                                                                    </small>
                                                                    <select id={controls?.selects?.informCreationUser.id}
                                                                        disabled={process.selUserDisabled || process?.showLoading}
                                                                        className={controls?.selects?.informCreationUser.defaultClass}
                                                                        style={{ borderRadius: '5px' }}
                                                                        value={!isUndNullEmp({ data: requirement?.informCreationUserId, subMethod: controls?.selects?.informCreationUser.id, })?.result ?
                                                                            requirement?.informCreationUserId : ``
                                                                        }
                                                                        onChange={(e) => setRequirement({ ...requirement, informCreationUserId: e?.target?.value, })}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, informCreationUser: '' }))}>
                                                                        <option key={`nothing`} value={``}>{messages?.selectUser?.[languageObj?.id]}</option>
                                                                        {users?.map((user) => <option key={user.id} value={user.id}>{user.firstName}, {user.lastName}</option>)}
                                                                    </select>
                                                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors.informCreationUser)}</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='row'>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'>
                                                                    <div className='custom-control custom-switch' style={{ cursor: process?.showLoading ? 'default' : 'pointer' }}>
                                                                        <input id={controls.checkBoxs.informCompletion.id}
                                                                            disabled={process?.showLoading}
                                                                            type='checkbox'
                                                                            className='custom-control-input'
                                                                            style={{ cursor: process?.showLoading ? 'default' : 'pointer' }}
                                                                            onClick={(e) => setRequirementInformCreationComplete({ e: e, id: e?.currentTarget?.id, subMethod: e?.currentTarget?.id })} />
                                                                        <label className='custom-control-label font-weight-bold text-muted text-uppercase small'
                                                                            style={{ cursor: process?.showLoading ? 'default' : 'pointer' }}
                                                                            htmlFor={controls.checkBoxs.informCompletion.id}>
                                                                            {labels?.informCompletion[languageObj?.id]}?
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.faFa?.calendarAlt}`} /> {labels?.date?.[languageObj?.id]}
                                                                    </small>
                                                                    <div id={controls?.pickers?.userRegisterDate?.id} className='input-group date' data-target-input='nearest'>
                                                                        <input id={controls?.inputs?.informCompletionDate.id}
                                                                            readOnly
                                                                            className={controls?.inputs?.informCompletionDate.defaultClass}
                                                                            style={{ borderRadius: '5px' }}
                                                                            value={!isUndNullEmp({ data: requirement?.informCompletionDate, subMethod: controls?.inputs?.informCompletionDate.id, })?.result ?
                                                                                setDateTimeFormatGlobalString({
                                                                                    date: requirement?.informCompletionDate,
                                                                                    dateFormat: languageObj?.format?.date?.f1,
                                                                                    timeFormat: languageObj?.format?.time?.type,
                                                                                    withSeconds: false,
                                                                                    languageId: languageObj?.id,
                                                                                    subMethod: currentMethod
                                                                                })?.result : ''} />
                                                                        <div className='input-group-append' data-target={``}>
                                                                            <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'></div>
                                                        </div>

                                                    </form>
                                                ) : (
                                                    <>
                                                        <div className='row'>
                                                            <div className='col-12 col-md-3 mb-3'>
                                                                <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.hashTag}`} /> {labels?.number?.[languageObj?.id]}
                                                                    </small>
                                                                    <span className='h6 mb-0 font-weight-bold text-dark'>{requirement?.id || '---'}</span>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-3 mb-3'>
                                                                <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.toggleOn}`} /> {labels?.status?.[languageObj?.id]}
                                                                    </small>
                                                                    <span className='h6 mb-0 font-weight-bold text-dark'>{parse(rFieldsView?.status || '---')}</span>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-3 mb-3'>
                                                                <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.faFa?.calendarAlt}`} /> {labels?.register?.[languageObj?.id]}
                                                                    </small>
                                                                    <span className='h6 mb-0 font-weight-bold text-dark'>{rFieldsView?.register?.date || '---'}</span>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-3 mb-3'>
                                                                <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.faFa?.calendarAlt}`} /> {labels?.visitDate?.[languageObj?.id]}
                                                                    </small>
                                                                    <span className='h6 mb-0 font-weight-bold text-dark'>{rFieldsView?.visit?.date || '---'}</span>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-6 mb-3'>
                                                                <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.user}`} /> {labels?.user?.[languageObj?.id]}
                                                                    </small>
                                                                    <span className='h6 mb-0 font-weight-bold text-dark'>{rFieldsView?.users?.customer?.name || '---'}</span>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-6 mb-3'>
                                                                <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.userTie}`} /> {labels?.analyst?.[languageObj?.id]}
                                                                    </small>
                                                                    <span className='h6 mb-0 font-weight-bold text-dark'>{rFieldsView?.users?.analyst?.name || '---'}</span>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4 mb-3'>
                                                                <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.userShield}`} /> {labels?.authorizedBy?.[languageObj?.id]}
                                                                    </small>
                                                                    <span className='h6 mb-0 font-weight-bold text-dark'>{requirement?.authorizedBy || '---'}</span>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4 mb-3'>
                                                                <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.userTag}`} /> {labels?.contactPerson?.[languageObj?.id]}
                                                                    </small>
                                                                    <span className='h6 mb-0 font-weight-bold text-dark'>{requirement?.contactPerson || '---'}</span>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4 mb-3'>
                                                                <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.building}`} /> {labels?.department?.[languageObj?.id]}
                                                                    </small>
                                                                    <span className='h6 mb-0 font-weight-bold text-dark'>{requirement?.department || '---'}</span>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 mb-3'>
                                                                <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={`${icons?.fasFa?.edit}`} /> {labels?.commentary?.[languageObj?.id]}
                                                                    </small>
                                                                    <span className='h6 mb-0 font-weight-bold text-dark d-block' style={{ whiteSpace: 'pre-wrap' }}>{requirement?.commentary || '---'}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {(userRoles?.isAdmin || userRoles?.isAnalyst) && (
                                                            <div className='row mt-2'>
                                                                <div className='col-12 col-md-4 mb-3'>
                                                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={`${icons?.fasFa?.infoCircle}`} /> {labels?.informCreation?.[languageObj?.id]}
                                                                        </small>
                                                                        <div className='custom-control custom-switch custom-switch-off-danger custom-switch-on-success'>
                                                                            <input id={`${controls.checkBoxs.informCreation.id}_view`}
                                                                                readOnly
                                                                                disabled
                                                                                type='checkbox'
                                                                                className='custom-control-input'
                                                                                checked={requirement?.informCreation || false} />
                                                                            <label className='custom-control-label small font-weight-bold text-muted text-uppercase' htmlFor={`${controls.checkBoxs.informCreation.id}_view`}>
                                                                                {requirement?.informCreation ? labels?.yes?.[languageObj?.id] : labels?.no?.[languageObj?.id]}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-12 col-md-4 mb-3'>
                                                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={`${icons?.faFa?.calendarAlt}`} /> {labels?.date?.[languageObj?.id]}
                                                                        </small>
                                                                        <span className='h6 mb-0 font-weight-bold text-dark'>
                                                                            {setDateTimeFormatGlobalString({
                                                                                date: requirement?.informCreationDate,
                                                                                dateFormat: languageObj?.format?.date?.f1,
                                                                                timeFormat: languageObj?.format?.time?.type,
                                                                                withSeconds: false,
                                                                                languageId: languageObj?.id,
                                                                                subMethod: currentMethod
                                                                            })?.result || '---'}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className='col-12 col-md-4 mb-3'>
                                                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={`${icons?.fasFa?.user}`} /> {labels?.user?.[languageObj?.id]}
                                                                        </small>
                                                                        <span className='h6 mb-0 font-weight-bold text-dark'>{rFieldsView?.users?.user?.name || '---'}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='col-12 col-md-4 mb-3'>
                                                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={`${icons?.fasFa?.infoCircle}`} /> {labels?.informCompletion[languageObj?.id]}
                                                                        </small>
                                                                        <div className='custom-control custom-switch custom-switch-off-danger custom-switch-on-success'>
                                                                            <input id={`${controls.checkBoxs.informCompletion.id}_view`}
                                                                                readOnly
                                                                                disabled
                                                                                type='checkbox'
                                                                                className='custom-control-input'
                                                                                checked={requirement?.informCompletion || false} />
                                                                            <label className='custom-control-label small font-weight-bold text-muted text-uppercase' htmlFor={`${controls.checkBoxs.informCompletion.id}_view`}>
                                                                                {requirement?.informCompletion ? labels?.yes?.[languageObj?.id] : labels?.no?.[languageObj?.id]}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-12 col-md-4 mb-3'>
                                                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={`${icons?.faFa?.calendarAlt}`} /> {labels?.date?.[languageObj?.id]}
                                                                        </small>
                                                                        <span className='h6 mb-0 font-weight-bold text-dark'>
                                                                            {setDateTimeFormatGlobalString({
                                                                                date: requirement?.informCompletionDate,
                                                                                dateFormat: languageObj?.format?.date?.f1,
                                                                                timeFormat: languageObj?.format?.time?.type,
                                                                                withSeconds: false,
                                                                                languageId: languageObj?.id,
                                                                                subMethod: currentMethod
                                                                            })?.result || '---'}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                                <hr className='opacity-50 my-4' />

                                                <div className='d-flex flex-wrap justify-content-end align-items-center mt-3 mb-2' style={{ gap: '8px' }}>
                                                    <button id={controls?.buttons?.save?.id}
                                                        className={controls?.buttons?.save?.defaultClass}
                                                        disabled={process.save || viewType !== 1}
                                                        hidden={viewType !== 1}
                                                        onClick={(e) => editRequirement({ e: e, subMethod: controls?.buttons?.save?.id, })}
                                                        tooltip='tooltip'
                                                        title={labels?.save?.[languageObj?.id]}
                                                        type='submit'>
                                                        {process?.save ? (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        ) : (
                                                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.defaultClass} />
                                                        )} {labels?.save?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.addDetail.id}
                                                        className={controls?.buttons?.addDetail.defaultClass}
                                                        disabled={process.detail || viewType !== 1}
                                                        hidden={viewType !== 1}
                                                        onClick={(e) => getRequirementDetailAdd({ e: e, subMethod: e?.currentTarget?.id })}
                                                        tooltip='tooltip'
                                                        title={labels?.addDetail?.[languageObj?.id]}
                                                        type='button'>
                                                        {process?.detail ? (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        ) : (
                                                            <i id={controls?.icons?.addDetail?.id} className={controls?.icons?.addDetail?.defaultClass} />
                                                        )} {labels?.addDetail?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.edit?.id}
                                                        className={controls?.buttons?.edit?.defaultClass}
                                                        disabled={process.edit || viewType !== 2 || (!userRoles?.isAdmin && !userRoles?.isAnalyst)}
                                                        hidden={viewType !== 2 || (!userRoles?.isAdmin && !userRoles?.isAnalyst)}
                                                        onClick={(e) => goToEdit({ e: e, subMethod: controls?.buttons?.edit?.id, })}
                                                        tooltip='tooltip'
                                                        title={labels?.edit?.[languageObj?.id]}
                                                        type='button'>
                                                        {process?.edit ? (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        ) : (
                                                            <i id={controls?.icons?.edit?.id} className={controls?.icons?.edit?.defaultClass} />
                                                        )} {labels?.edit?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.report.id}
                                                        className={controls?.buttons?.report.defaultClass}
                                                        disabled={process.report || viewType !== 2}
                                                        hidden={viewType !== 2}
                                                        onClick={(e) => getRequirementReport({ e: e, subMethod: e?.currentTarget?.id, })}
                                                        tooltip='tooltip'
                                                        title={labels?.report?.[languageObj?.id]}
                                                        type='button'>
                                                        {process?.report ? (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        ) : (
                                                            <i id={controls?.icons?.report?.id} className={controls?.icons?.report?.defaultClass} />
                                                        )} {labels?.report?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.back?.id}
                                                        className={controls?.buttons?.back?.defaultClass}
                                                        disabled={process.back}
                                                        tooltip='tooltip'
                                                        title={labels?.back?.[languageObj?.id]}
                                                        type='reset'
                                                        onClick={() => goToBack({ subMethod: controls?.buttons?.back?.id })}>
                                                        {process?.back ? (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        ) : (
                                                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.defaultClass} />
                                                        )} {labels?.back?.[languageObj?.id]}
                                                    </button>
                                                </div>
                                                <hr />

                                                {/* Section: Details */}
                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.listUl} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.details?.[languageObj?.id]}</h6>
                                                </div>

                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className={`${html?.dataTables?.formats?.tableResponsiveSm} bg-white rounded shadow-sm p-2`}>
                                                            <table id={dtRequirementDetailsId}
                                                                className={html?.dataTables?.formats?.tableHoverW100Border0} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* /.card-body */}
                                        </div>

                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className='text-center py-5'>
                                <i className={`${icons?.fasFa?.lock} fa-3x text-muted mb-3`}></i>
                                <h3 className='text-muted'>{messages?.accessDenied?.[languageObj?.id]}</h3>
                            </div>
                        )}

                    </div>
                </section>

            </div>

            {modalObj?.showModal ?
                <RequirementDetailAddEditDetail
                    modalObj={modalObj}
                    setModalObj={setModalObj} />
                :
                <div></div>
            }
        </div>
    )
}